import React from "react";
import { BaseComponent } from "..";
import { PopupService } from "../Macros/Popup";
import Header from "./Header";
import Status from "./Status";
import FundDetails from "./FundDetails";
import Liquidity from "./Liquidity";
import ManagementFees from "./ManagementFees";
import { Tab, Nav } from "react-bootstrap";
import Transactions from "./Transactions";
import PaymentClassification from "./PaymentClassification";
import DepositDetails from "./DepositDetails";
import { CmsBanners } from "../Macros";
import { UserDataService } from "../../services";
import { AccountStatusApi } from "../../api";
import { BalanceApi } from "../../api";
import moment from "moment";

const pageSize = 20;
export default class AccountStatus extends BaseComponent {
  cmsPageAlias = "accountstatus";
  constructor(props) {
    super(props);
    const accountId = this.props.match.params.id;
    const fundType = this.props.match.params.fundType;
    this.state = {
      routes: this.getRoutes(accountId),
      accountId: accountId,
      fundType: parseInt(fundType),
      depositViewType: "depositDetails", // 'depositDetails' or 'paymentClassification'
      depositCompareData: [],
      isLoadingDepositCompare: false,
      paymentClassificationData: [],
      isLoadingPaymentClassification: false,
      isLoadingExcel: false,
      paymentClassificationPages: 1,
      depositComparePages: 1,
      depositComparePageNo: 1,
      paymentClassificationPageNo: 1,
    };
    this.onAccountSelected = this.onAccountSelected.bind(this);
    this.fetchDepositCompare = this.fetchDepositCompare.bind(this);
    this.fetchPaymentClassification =
      this.fetchPaymentClassification.bind(this);
    this.exportExcelDepositCompare = this.exportExcelDepositCompare.bind(this);
    this.exportExcelPaymentComponents =
      this.exportExcelPaymentComponents.bind(this);
  }

  onAccountSelected(newAccount) {
    this.setState({
      routes: this.getRoutes(newAccount),
      accountId: newAccount,
    });
  }

  getRoutes(accountId) {
    const id = parseInt(accountId);
    return UserDataService.data.accounts.find((x) => x.id === id).courses;
  }

  fetchDepositCompare(page, year = null) {
    this.setState({
      isLoadingDepositCompare: true,
      depositComparePageNo: page,
    });
    AccountStatusApi.getEmployeeDepositCompare({
      accountNumber: this.state.accountId,
      pageSize: pageSize,
      pageNo: page || 1,
      salaryYear: year || null
    })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const transformedData = res.data.map((item, index) => ({
            ...item, // Keep all original data for expanded row
            key: item.rn || index + 1,
            id: item.rn || index + 1,
            salaryMonth: item.salaryMonth,
            depositDate: moment(item.depositDate).format("DD/MM/YYYY"),
            match: item.isMatch === 1 ? "כן " : "לא",
          }));
          this.setState({
            depositCompareData: transformedData,
            isLoadingDepositCompare: false,
            depositComparePages:
              res.totalCount > pageSize
                ? Math.ceil(res.totalCount / pageSize)
                : 1,
          });
        } else {
          this.setState({
            depositCompareData: [],
            isLoadingDepositCompare: false,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching deposit compare data:", err);
        this.setState({
          depositCompareData: [],
          isLoadingDepositCompare: false,
        });
      });
  }

  fetchPaymentClassification(page, year = null) {
    const personId = JSON.parse(sessionStorage.getItem("user")).username;
    this.setState({
      isLoadingPaymentClassification: true,
      paymentClassificationPageNo: page,
    });
    AccountStatusApi.getEmployeePaymentClassification({
      accountNumber: this.state.accountId,
      personId: personId,
      fundType: this.state.fundType,
      pageSize: pageSize,
      pageNo: page || 1,
      yearTax: year
    })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const transformedData = res.data.map((item, index) => ({
            ...item,
            key: item.rn || index + 1,
            id: item.rn || index + 1,
          }));
          this.setState({
            paymentClassificationData: transformedData,
            isLoadingPaymentClassification: false,
            paymentClassificationPages:
              res.totalCount > pageSize
                ? Math.ceil(res.totalCount / pageSize)
                : 1,
          });
        } else {
          this.setState({
            paymentClassificationData: [],
            isLoadingPaymentClassification: false,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching payment classification data:", err);
        this.setState({
          paymentClassificationData: [],
          isLoadingPaymentClassification: false,
        });
      });
  }

  exportExcelPaymentComponents(year = null) {
    const personId = JSON.parse(sessionStorage.getItem("user")).username;
    this.setState({
      isLoadingExcel: true,
    });
    AccountStatusApi.exportExcelPaymentComponents({
      accountNumber: this.state.accountId,
      personId: personId,
      fundType: this.state.fundType,
      pageSize: 1000000,
      yearTax: year
    })
      .then((res) => {
        this.setState({ isLoadingExcel: false });
        if (res.downloadUrl) {
          console.log(res.downloadUrl);
          document.location.href = res.downloadUrl;
        } else {
          console.error("Invalid downloadUrl in response:", res);
        }
      })
      .catch((err) => {
        console.error("Error fetching deposit compare data:", err);
        this.setState({
          isLoadingExcel: false,
        });
      });
  }

  exportExcelDepositCompare(year = null) {
    const personId = JSON.parse(sessionStorage.getItem("user")).username;
    this.setState({
      isLoadingExcel: true,
    });
    AccountStatusApi.exportExcelDepositCompare({
      accountNumber: this.state.accountId,
      personId: personId,
      pageSize: 1000000,
      pageNo: 1,
      salaryYear: year || null,
    })
      .then((res) => {
        this.setState({ isLoadingExcel: false });
        if (res.downloadUrl) {
          console.log(res.downloadUrl);
          document.location.href = res.downloadUrl;
        }
      })
      .catch((err) => {
        console.error("Error fetching deposit compare data:", err);
        this.setState({ isLoadingExcel: false });
      });
  }

  componentDidMount() {
    this.fetchDepositCompare();
    this.fetchPaymentClassification();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.accountId !== this.state.accountId) {
      this.fetchDepositCompare();
      this.fetchPaymentClassification();
    }
  }

  render() {
    return (
      <>
        <Header
          accountId={this.state.accountId}
          routes={this.state.routes}
          onAccountSelected={this.onAccountSelected.bind(this)}
        />

        <div className="content-wrapper content-wrapper--sheet">
          <div className="content-sheet">
            <div className="account-data">
              <Tab.Container id="account-tab" defaultActiveKey="status">
                <div className="account-data__header">
                  <div className="account-data__date-col">
                    {this.label("balances_date")}{" "}
                    <time dateTime="2019-03-11" className="number">
                      {sessionStorage.getItem("updatedate")}
                    </time>
                  </div>

                  <Nav
                    variant={null}
                    className="nav nav-tabs account-data__nav-tabs"
                  >
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="status"
                        className="nav-link account-data__nav-link"
                      >
                        {this.label("account_accStatus")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="fundDetails"
                        className="nav-link account-data__nav-link"
                      >
                        {" "}
                        {this.label("account_details")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="transactions"
                        className="nav-link account-data__nav-link"
                      >
                        {this.label("account_movements")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="deposit"
                        className="nav-link account-data__nav-link"
                      >
                        {this.label("account_deposit")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="liquidity"
                        className="nav-link account-data__nav-link d-none"
                      >
                        {this.label("account_liquid")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item account-data__nav-item">
                      <Nav.Link
                        eventKey="management"
                        className="nav-link account-data__nav-link d-none"
                      >
                        {this.label("account_fee")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>

                <Tab.Content className="tab-content account-data__tabs-content">
                  <Tab.Pane eventKey="status">
                    <Status accountId={this.state.accountId} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="fundDetails">
                    <FundDetails accountId={this.state.accountId} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="transactions">
                    <Transactions accountId={this.state.accountId} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="liquidity">
                    <Liquidity />
                  </Tab.Pane>
                  <Tab.Pane eventKey="deposit">
                    <div
                      className="deposit-options"
                      style={{
                        marginBottom: "20px",
                        padding: "15px",
                        direction: "rtl",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          justifyContent: "flex-start",
                          direction: "rtl",
                        }}
                      >
                        <label
                          className="update-form__radio-label"
                          style={{ margin: 0 }}
                        >
                          <span style={{ marginRight: "25px" }}>
                            פירוט הפקדה
                          </span>
                          <input
                            type="radio"
                            name="depositViewType"
                            value="depositDetails"
                            checked={
                              this.state.depositViewType === "depositDetails"
                            }
                            onChange={(e) =>
                              this.setState({ depositViewType: e.target.value })
                            }
                          />
                          <span className="checkmark" />
                        </label>
                        <label
                          className="update-form__radio-label"
                          style={{ margin: 0 }}
                        >
                          <span style={{ marginRight: "25px" }}>
                            הפקדות לפי סיווג תשלומים
                          </span>
                          <input
                            type="radio"
                            name="depositViewType"
                            value="paymentClassification"
                            checked={
                              this.state.depositViewType ===
                              "paymentClassification"
                            }
                            onChange={(e) =>
                              this.setState({ depositViewType: e.target.value })
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                    </div>
                    <div
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                      }}
                    >
                      {this.state.depositViewType === "depositDetails" ? (
                        <DepositDetails
                          data={this.state.depositCompareData}
                          totalPages={this.state.depositComparePages}
                          totalCount={this.state.depositCompareData.length}
                          isLoading={this.state.isLoadingDepositCompare}
                          onPagination={this.fetchDepositCompare}
                          onExportExcel={this.exportExcelDepositCompare}
                          isLoadingExcel={this.state.isLoadingExcel}
                          pageNo={this.state.depositComparePageNo}
                        />
                      ) : (
                        <PaymentClassification
                          data={this.state.paymentClassificationData}
                          isLoading={this.state.isLoadingPaymentClassification}
                          accountId={this.state.accountId}
                          onPagination={this.fetchPaymentClassification}
                          totalPages={this.state.paymentClassificationPages}
                          onExportExcel={this.exportExcelPaymentComponents}
                          isLoadingExcel={this.state.isLoadingExcel}
                          pageNo={this.state.paymentClassificationPageNo}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="management">
                    <ManagementFees accountId={this.state.accountId} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>

        <CmsBanners banners={this.cmsContent && this.cmsContent.banners} />
      </>
    );
  }
}
